var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 979,
    height: 230,
    viewBox: "0 0 979 790.20144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "design inspiration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b19d480b-2e1235c-428123a-93f1230-37b20123c7a448d",
    "data-name": "ground"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.01439,798.86691c0,7.12407-161.70573,45.73381-361.17986,45.73381S271.65468,805.991,271.65468,798.86691s161.70573,4.69064,361.17985,4.69064S994.01439,791.74283,994.01439,798.86691Z",
    transform: "translate(-111 -54.39928)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.01439,798.86691c0,7.12407-161.70573,45.73381-361.17986,45.73381S271.65468,805.991,271.65468,798.86691s161.70573,4.69064,361.17985,4.69064S994.01439,791.74283,994.01439,798.86691Z",
    transform: "translate(-111 -54.39928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.83453,
    cy: 744.46763,
    rx: 361.17986,
    ry: 12.89928,
    fill: "#3f3d56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ab3f2562-bca9-4d43-aec7-516c7578bb8d",
    "data-name": "flowers"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 710.63309,
    y1: 738.60432,
    x2: 710.63309,
    y2: 506.41727,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.61151,
    y1: 742.1223,
    x2: 282.61151,
    y2: 626.02878,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.61151,
    cy: 626.02878,
    r: 16.41727,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.61151,751.9789s2.34532-50.44293,50.42446-44.57962",
    transform: "translate(-111 -54.39928)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.23741,
    y1: 740.94964,
    x2: 633.23741,
    y2: 624.85612,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 633.23741,
    cy: 624.85612,
    r: 16.41727,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.23741,750.80624s-2.34532-50.44293-50.42446-44.57962",
    transform: "translate(-111 -54.39928)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 861.90647,
    y1: 740.94964,
    x2: 861.90647,
    y2: 624.85612,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.90647,
    cy: 624.85612,
    r: 16.41727,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.90647,750.80624s-2.34532-50.44293-50.42446-44.57962",
    transform: "translate(-111 -54.39928)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.4964,
    y1: 738.60432,
    x2: 227.4964,
    y2: 506.41727,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.4964,
    cy: 506.41727,
    r: 16.41727,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.07194,
    cy: 636.58273,
    r: 16.41727,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.4964,627.67674s-2.34532-50.44293-50.42446-44.57962",
    transform: "translate(-111 -54.39928)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.4964,788.49082s10.554-92.81816-50.42446-97.50881",
    transform: "translate(-111 -54.39928)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.63309,
    cy: 506.41727,
    r: 16.41727,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.63309,627.67674s2.34533-50.44293,50.42446-44.57962",
    transform: "translate(-111 -54.39928)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.63309,788.49082s-10.55395-92.81816,50.42446-97.50881",
    transform: "translate(-111 -54.39928)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 761.05755,
    cy: 636.58273,
    r: 16.41727,
    fill: "#3f3d56"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "f0719385-ea67-4de2-93df-2f93190c33e6",
    "data-name": "woman"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 706.71223,
    y: 523.29137,
    width: 89.1223,
    height: 89.1223,
    transform: "translate(24.19656 -198.80902) rotate(12.05764)",
    fill: "#eb6475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae36c3dd-7325-441a-986f-f572badd95bc",
    "data-name": "right hand",
    d: "M700.8106,491.67876s32.01263,22.86617,21.34175,32.01263S690.13972,496.252,690.13972,496.252Z",
    transform: "translate(-111 -54.39928)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a62fff18-8892-42d4-80fd-3866da1ea571",
    "data-name": "left leg",
    d: "M552.94276,526.74021s6.09764,76.22054,7.622,86.89141,3.04882,106.70876,6.09764,117.37963,6.09765,36.58586,6.09765,36.58586H591.053s-1.52441-47.25673,3.04882-65.54966,3.04882-68.59849,3.04882-68.59849,9.14646-89.94023,4.57323-102.13552S552.94276,526.74021,552.94276,526.74021Z",
    transform: "translate(-111 -54.39928)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7318984-040f-4fc3-86a6-953621afd18f",
    "data-name": "left shoe",
    d: "M577.33333,763.02388s-7.62205,4.57323-7.62205,7.62205,1.52441,10.67088,0,13.7197-12.19529,15.24411-6.09765,18.29293,33.537,0,33.537,0-1.52441-21.34175-3.04882-22.86616,1.52441-16.76852,1.52441-16.76852Z",
    transform: "translate(-111 -54.39928)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a18c6c71-d9e5-4769-9c45-332356aaad40",
    "data-name": "right leg",
    d: "M669.47512,524.87219s1.93661,76.43952,1.5407,87.21146,8.16883,106.4393,6.25693,117.37125-2.22368,37.02379-2.22368,37.02379l-18.19188,1.92014s-3.44437-47.15569-9.91247-64.86753-10.2325-67.89951-10.2325-67.89951-18.53661-88.48332-15.26873-101.09127S669.47512,524.87219,669.47512,524.87219Z",
    transform: "translate(-111 -54.39928)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b445673f-d55c-440d-9265-e0f6f4384e92",
    "data-name": "right shoe",
    d: "M670.02106,762.41076s8.06,3.74791,8.38,6.77989-.39591,10.77194,1.4401,13.64391,13.728,13.8798,7.9841,17.55182-33.35177,3.52026-33.35177,3.52026-.72418-21.38387.6318-23.05987-3.27611-16.51587-3.27611-16.51587Z",
    transform: "translate(-111 -54.39928)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b24d9d75-0c14-4761-bcd9-0141722f6ab9",
    "data-name": "pants",
    d: "M574.28451,412.40941s-12.19529,1.52441-16.76852,27.43939-21.34175,91.46464-7.622,96.03788,54.87878,13.71969,56.40319,10.67087,4.57324-10.67087,4.57324-10.67087-4.57324,13.71969,1.52441,13.71969,65.54966-9.14646,64.02525-13.71969-4.57323-38.11027-4.57323-38.11027-9.14647-56.4032-18.29293-65.54966a24.99948,24.99948,0,0,1-7.62206-19.81734Z",
    transform: "translate(-111 -54.39928)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a623e943-b2fb-4cf0-84ac-14e2741ec9b3",
    "data-name": "left hand",
    d: "M551.41835,400.21412s19.81734-4.57323,22.86616,1.52441-7.62206,15.24411-12.19529,15.24411-12.19528-4.57323-12.19528-4.57323Z",
    transform: "translate(-111 -54.39928)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "aec06241-7975-4084-a0e1-2aae67cf4372",
    "data-name": "head",
    cx: 481.57744,
    cy: 188.80053,
    r: 27.43939,
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e1a5dc11-bb8d-4cf9-9d5f-cc3caf7654e4",
    "data-name": "neck",
    d: "M597.15067,263.01715s4.57323,21.34175,1.52441,21.34175,22.86616,13.7197,22.86616,13.7197l19.81734-3.04882,6.09764-9.14647s-32.01262-21.34175-32.01262-33.537S597.15067,263.01715,597.15067,263.01715Z",
    transform: "translate(-111 -54.39928)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "abced657-03a0-4589-99b7-99fe0bd67324",
    "data-name": "upper body",
    d: "M610.87037,284.3589s-4.57324-3.04882-6.09765-3.04882H592.57744c-1.52441,0-21.34175,4.57323-21.34175,4.57323L559.0404,354.4818s21.34175,35.06144,6.09764,62.50084c0,0,4.57324-3.04882,25.915-1.52441s59.452,6.09764,60.97643,6.09764,1.52441-12.19529,0-15.24411,1.52441-1.52441,1.52441-9.14646,4.57323-21.34175,4.57323-21.34175l21.34175-77.745s-27.43939-15.24411-32.01263-13.7197-18.29293,6.09765-21.34175,4.57323S610.87037,284.3589,610.87037,284.3589Z",
    transform: "translate(-111 -54.39928)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac5355b5-fe6d-4cac-8416-568b37b82055",
    "data-name": "left arm",
    d: "M575.80892,287.40772l-4.57323-1.52441s-9.14647-1.52441-19.81734,7.62206-50.30556,36.58585-50.30556,36.58585-15.24411,12.19529-10.67087,25.915,12.19528,47.25673,35.06144,45.73232c0,0,13.7197,18.29293,21.34175,15.24411s13.7197-15.24411,9.14647-16.76852-16.76852-16.76852-16.76852-16.76852l15.24411-28.9638h4.57323l16.76852-9.14647Z",
    transform: "translate(-111 -54.39928)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bbfb65e5-af11-42b0-84c8-419de26da4a4",
    "data-name": "right arm",
    d: "M667.27356,296.55419l12.19529,1.52441s10.67087,4.57323,9.14646,24.39057,9.14647,109.75758,4.57324,120.42845c0,0,15.2441,51.83,12.19528,53.35438s-21.34175,10.67087-19.81734,4.57323S668.798,452.04408,668.798,452.04408s-21.34175-22.86616-12.19528-54.87878v-25.915Z",
    transform: "translate(-111 -54.39928)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b4f25da6-b4a0-4bb2-b4da-2cd048bf1670",
    "data-name": "hair",
    d: "M575.04671,279.02346l19.81734-.80891v-9.862l1.56759,9.798,31.96945-1.30492v-5.4443l.86548,5.409,20.47627-.83581-12.19529-40.07281A31.57457,31.57457,0,0,0,605.973,204.32734H598.237c-12.80769,0-33.86119,8.53415-33.86119,21.34175C575.30965,245.14533,590.62894,265.62718,575.04671,279.02346Z",
    transform: "translate(-111 -54.39928)",
    fill: "#2f2e41"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "a0d75b13-789a-427c-b6ce-87e1117c1e36",
    "data-name": "objects"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "f48beb42-1425-4c1f-8a80-c4b29bfc69ca",
    "data-name": "outline",
    x: 238.05036,
    y: 20.93525,
    width: 89.1223,
    height: 89.1223,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "e5668835-c1a2-4738-803a-e82934b413de",
    "data-name": "second object"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ab26e1cd-ed2d-4718-9a90-5508d704a3b1",
    "data-name": "fill",
    x: 644.96403,
    y: 19.76259,
    width: 310.7554,
    height: 147.7554,
    fill: "#eb6475"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ea8f1f59-00f0-4c1b-ada9-716e448c4de5",
    "data-name": "outline",
    x: 667.2446,
    y: 1,
    width: 310.7554,
    height: 147.7554,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "ba29742d-42d4-459b-9ccd-d399049cb642",
    "data-name": "first object"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bd7d2a9f-47f9-417c-9ce5-d36b6a614406",
    "data-name": "fill",
    y: 270.71223,
    width: 310.7554,
    height: 147.7554,
    fill: "#eb6475"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b1bb1ad4-cb36-48f5-bc5b-cbf5d51e5b88",
    "data-name": "outline",
    x: 22.28058,
    y: 251.94964,
    width: 310.7554,
    height: 147.7554,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.9601fede4c9c28ef6e9e246630d3c156.svg";
export { ForwardRef as ReactComponent };